import React from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Head from "next/head";
import { usePathname } from "../../hooks/useNavigation";
import PropTypes from "prop-types";

function Seo(props) {
  const { seoAttributes, siteName } = props;

  if (!seoAttributes) {
    return null;
  }

  const {
    metaTitle,
    metaDescription,
    metaRobots,
    metaImage,
    keywords,
    canonicalUrl,
    noFollow,
    validThrough,
    noIndex,
  } = seoAttributes;

  const pathname = usePathname();
  return (
    <Head>
      <title key="siteTitle">{`${siteName || seoAttributes.metaTitle}`}</title>
      {(noFollow || noIndex) && (
        <meta key="seo-robots" name="robots" content="noindex, nofollow" />
      )}
      {validThrough && (
        <meta
          key="seo-validThrough"
          content={validThrough}
          name="validThrough"
        />
      )}
      {metaTitle && (
        <meta key="seo-og:title" content={metaTitle} property="og:title" />
      )}
      {metaDescription && (
        <>
          <meta
            key="seo-description"
            name="description"
            content={metaDescription}
          />
          <meta
            key="seo-og:description"
            content={metaDescription}
            property="og:description"
          />
        </>
      )}
      {!isEmpty(metaImage) && (
        <meta
          key="seo-og:image"
          content={`${metaImage.url}`}
          property="og:image"
        />
      )}
      <meta
        key="seo-og:url"
        content={`${process.env.FRONTEND_URL}${pathname}`}
        property="og:url"
      />
      {siteName && (
        <meta
          key="seo-og:site_name"
          content={siteName}
          property="og:site_name"
        />
      )}
      {canonicalUrl && (
        <link
          key="seo-canonical"
          href={`${process.env.FRONTEND_URL}${canonicalUrl}`}
          rel="canonical"
        />
      )}
      <meta key="seo-og:type" content="article" property="og:type" />
      <meta
        key="seo-viewport"
        content="width=device-width, initial-scale=1.0"
        name="viewport"
      />
      {keywords && (
        <meta key="seo-keywords" content={keywords} property="keywords" />
      )}
      {metaRobots && (
        <meta key="seo-metaRobots" content={metaRobots} property="googlebot" />
      )}
      {siteName && (
        <meta
          key="seo-og:site_name"
          content={`${siteName}`}
          property="og:site_name"
        />
      )}
    </Head>
  );
}

Seo.defaultProps = {
  seoAttributes: null,
  siteName: "",
};

Seo.propTypes = {
  seoAttributes: PropTypes.shape({
    canonicalUrl: PropTypes.string,
    noFollow: PropTypes.bool,
    validThrough: PropTypes.string,
    keywords: PropTypes.string,
    metaDescription: PropTypes.string,
    metaImage: PropTypes.shape({
      data: PropTypes.shape({
        attributes: PropTypes.shape({ url: PropTypes.string }),
      }),
    }),
    metaRobots: PropTypes.string,
    metaTitle: PropTypes.string,
    metaViewport: PropTypes.string,
    noIndex: PropTypes.bool,
  }),
  siteName: PropTypes.string,
};

export default observer(Seo);
